import {Permission, PERMISSION_STATE, SessionStore, UIStore} from '../store';
import {Loading} from 'quasar';
import {NativeSettings, AndroidSettings, IOSSettings} from 'capacitor-native-settings';
import {Geolocation} from '@capacitor/geolocation';

class Location {
	async getCurrentPosition() {
		const result = await Geolocation.getCurrentPosition();
		SessionStore.setLastLocation(result);
		return result;
	}

	async requestGeolocation() {
		// We don't have an explicit "requirePermission" for this
		try {
			const result = await this.getCurrentPosition();
			UIStore.setShowGeolocationRequest(false);
			// Make this call again to update the Session with the new permissions
			this.getPermissionState();
			console.log(result);
		} catch(error) {
			console.error(error);
			UIStore.setShowGeolocationRequest(false);
			const state = await this.getPermissionState();
			if(state === PERMISSION_STATE.DENIED) {
				// We've asked the user for permission, but they have denied it
				// We will redirect them to our help page
				UIStore.setShowGeolocationDisabled(true);
			}
		}
	}

	async isPermissionGranted() {
		const state = await this.getPermissionState();
		return state === PERMISSION_STATE.GRANTED;
	}

	async getPermissionState() {
		const result = await Geolocation.checkPermissions();
		SessionStore.setPermissionState({
			name: Permission.LOCATION,
			state: result.location
		});
		return result.location;
	}

	async enableGeolocation() {
		const state = await this.getPermissionState();

		if(state === PERMISSION_STATE.GRANTED) {
			// Do nothing
			return true;
		} else if(state === PERMISSION_STATE.PROMPT) {
			// We've never asked the user for permission (system), so we will pop our own request first
			UIStore.setShowGeolocationRequest(true);
			return false;
		} else if(state === PERMISSION_STATE.DENIED) {
			// We've asked the user for permission, but they have denied it
			// We will redirect them to our help page
			UIStore.setShowGeolocationDisabled(true);
			return false;
		}
	}

	async openLocationSettings() {
		Loading.show();
		try {
			await NativeSettings.open({
				optionIOS: IOSSettings.App,
				optionAndroid: AndroidSettings.Location,
			});
		} catch(error) {
			console.error(error);
		}
		Loading.hide();
	}
}

export const LocationService = new Location();
